import { TRIM_DOCUMENT_NAME_REGEX } from 'src/constants/constant';

export const filterDocument = (document, selectedTopic, selectedVideo) => {
  const arrayMatch = document.name.match(TRIM_DOCUMENT_NAME_REGEX);
  return +arrayMatch[1] === selectedTopic + 1;
};

export const filterDocumentName = (name) => name.match(TRIM_DOCUMENT_NAME_REGEX).slice(-1);
